import {TurnState} from '@colonist/game-states'
import {useGameStore} from '../GameStoreContext'
import {useIsReplay} from './useIsReplay'

export const useIsGameEnded = () => {
    const isReplay = useIsReplay()
    if(isReplay) return true

    const turnState = useGameStore((state) => state.gameState.currentState.turnState)
    return turnState === TurnState.GameEnd
}
